import React from "react";

interface AddAnotherItemButtonProps {
    onAdd: () => void;
    className?: string;
}

const AddAnotherItemButton: React.FC<AddAnotherItemButtonProps> = ({ onAdd, className }) => {
    return (
        <button
            onClick={onAdd}
            className={`primary flex-1 text-center ${className}`}
        >
            Add Another Item
        </button>
    );
};

export default AddAnotherItemButton;
